import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import NotificationWindow from '../NotificationWindow';
import { GLOBAL_MESSAGES } from '../../utils/constants';
import PropType from 'prop-types';

class ErrorNotificationPage extends Component {
  constructor(props) {
    super(props);

    this.onCloseNotification = this.onCloseNotification.bind(this);
  }

  onCloseNotification() {
    const { dispatch, redirectUrl } = this.props;

    dispatch(push(redirectUrl ? redirectUrl : '/'));
  }

  render() {
    const { notificationMessage } = this.props;

    if (notificationMessage) {
      let message = notificationMessage;

      if (GLOBAL_MESSAGES[message]) {
        message = GLOBAL_MESSAGES[message];
      }

      return (
        <NotificationWindow
          message={message}
          close={this.onCloseNotification}
        />
      );
    }

    return <div>{this.props.children}</div>;
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(null, mapDispatchToProps)(ErrorNotificationPage);

ErrorNotificationPage.propTypes = {
  notificationMessage: PropType.string,
  redirectUrl: PropType.string
};



// WEBPACK FOOTER //
// ./src/components/ErrorNotificationPage/index.js